import { BaseQueryFn, createApi, FetchArgs, fetchBaseQuery, FetchBaseQueryError } from '@reduxjs/toolkit/query/react';
import { v4 as uuidv4 } from 'uuid';
import { getSettings, SettingsState } from '@vxui/common';
import { Prober, ProberApiResult, ProbeRequestBody } from '../models';
import { defaultTimeout, setProberProfilesIndexForRtmp } from './prober.helpers';

const rawBaseQuery = fetchBaseQuery();
const dynamicBaseQuery: BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError> = async (
  args,
  api,
  extraOptions,
) => {
  const settings = getSettings(api.getState() as SettingsState);
  const urlEnd = typeof args === 'string' ? args : args.url;
  const adjustedUrl = `${settings?.servers.serverProber ?? ''}/api/v1/${urlEnd}`;
  const adjustedArgs = typeof args === 'string' ? adjustedUrl : { ...args, url: adjustedUrl };
  return rawBaseQuery(adjustedArgs, api, extraOptions);
};

export const proberApi = createApi({
  reducerPath: 'proberApi',
  baseQuery: dynamicBaseQuery,
  keepUnusedDataFor: 5,
  endpoints: builder => ({
    probe: builder.mutation<Prober, ProbeRequestBody>({
      query: ({ name, source, id = uuidv4(), timeout = defaultTimeout, serviceUUID }) => ({
        url: 'prober',
        method: 'POST',
        body: {
          id,
          name: name ?? `probe-${id}`,
          source,
          timeout,
          serviceUUID,
        },
      }),
      transformResponse: (response: ProberApiResult) => {
        const result: Prober = response?.data?.attributes ?? {};
        if (result.format?.filename?.includes('rtmp')) {
          setProberProfilesIndexForRtmp(result.audio);
          setProberProfilesIndexForRtmp(result.video);
        }
        return result;
      },
    }),
  }),
});

export const { useProbeMutation } = proberApi;
